import type { OrbitForgeRuntime } from "../game/runtime/runtime";

export function startGameLoop(runtime: OrbitForgeRuntime): () => void {
  let running = true;
  let previousTime = performance.now();
  let frameId = 0;

  const tick = (time: number) => {
    if (!running) {
      return;
    }

    const deltaSeconds = Math.max(0, (time - previousTime) / 1000);
    previousTime = time;
    runtime.tick(deltaSeconds, window.localStorage);
    frameId = window.requestAnimationFrame(tick);
  };

  frameId = window.requestAnimationFrame(tick);

  const flush = () => runtime.flushSave(window.localStorage);
  window.addEventListener("pagehide", flush);
  window.addEventListener("beforeunload", flush);

  return () => {
    running = false;
    window.cancelAnimationFrame(frameId);
    window.removeEventListener("pagehide", flush);
    window.removeEventListener("beforeunload", flush);
    flush();
  };
}
